import React, {useState} from 'react';

import {Modal} from '@optimaxdev/design-system';
import {Icon, Exit} from '@optimaxdev/icons';
import classNames from 'classnames';

import {BannerContentType} from '../../types';
import {Coupon} from '../coupon/coupon';

import s from './popup.scss';

export type PropsType = {
    isOpen: boolean;
    closeModal: () => void;
    data: BannerContentType;
};

const MODAL_OPTIONS = {
    overflow: 'hidden',
};

/**
 * A popup for the banner item
 */
export const Popup: React.FC<PropsType> = ({closeModal, data, isOpen}) => {
    const [isSticky, setIsSticky] = useState(false);

    const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
        const {scrollTop} = event.target as HTMLDivElement;
        if (Number(scrollTop) > 0) setIsSticky(true);
        if (Number(scrollTop) === 0) setIsSticky(false);
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            options={MODAL_OPTIONS}
            overlay="dark"
            isAnimationEnabled
            shouldCloseOnOverlayClick
            withoutCloses
        >
            <div className={s.container} onScroll={handleScroll}>
                <div className={classNames(s.header, {[s.headerShadow]: isSticky})}>
                    <h2 className={s.title}>{data.details_headline}</h2>
                    <button
                        aria-label="Close modal"
                        className={s.exitButton}
                        onClick={closeModal}
                        type="button"
                    >
                        <Icon className={s.icon} icon={Exit} />
                    </button>
                </div>
                <ul className={s.list}>
                    {data.coupons.map(coupon => (
                        <Coupon coupon={coupon} key={coupon.title} />
                    ))}
                </ul>
                <p className={s.footer}>{data.details_footer}</p>
            </div>
        </Modal>
    );
};
